import clamp from 'lodash/clamp';
import {
  DEFAULT_SCHEDULE_COLUMN_CAROUSEL_INTERVAL_SECONDS,
  DEFAULT_SCHEDULE_COLUMN_MAX_COLUMNS,
  DEFAULT_SCHEDULE_COLUMN_WIDTH_PERCENT,
  MAX_SCHEDULE_COLUMN_CAROUSEL_INTERVAL_SECONDS,
  MAX_SCHEDULE_COLUMN_MAX_COLUMNS,
  MAX_SCHEDULE_COLUMN_WIDTH_PERCENT,
  MIN_SCHEDULE_COLUMN_CAROUSEL_INTERVAL_SECONDS,
  MIN_SCHEDULE_COLUMN_MAX_COLUMNS,
  MIN_SCHEDULE_COLUMN_WIDTH_PERCENT,
} from './scheduleColumn.constants';

// Stored values may be null, zero, NaN, or out of range. Preserve the existing fallback-first
// behavior, then clamp every schedule-column numeric setting to its admin bounds.
const coalesceAndClamp = (value: number | null | undefined, fallback: number, min: number, max: number): number =>
  clamp(value || fallback, min, max);

export const clampWidthPercent = (value?: number | null): number =>
  coalesceAndClamp(
    value,
    DEFAULT_SCHEDULE_COLUMN_WIDTH_PERCENT,
    MIN_SCHEDULE_COLUMN_WIDTH_PERCENT,
    MAX_SCHEDULE_COLUMN_WIDTH_PERCENT
  );

// maxColumns = 1 (the default, and what a missing value coalesces to) is the structural degenerate
// case: one column, no MAX-width clamp, preserving the existing single-column behavior.
export const clampMaxColumns = (value?: number | null): number =>
  coalesceAndClamp(
    value,
    DEFAULT_SCHEDULE_COLUMN_MAX_COLUMNS,
    MIN_SCHEDULE_COLUMN_MAX_COLUMNS,
    MAX_SCHEDULE_COLUMN_MAX_COLUMNS
  );

export const clampCarouselIntervalSeconds = (value?: number | null): number =>
  coalesceAndClamp(
    value,
    DEFAULT_SCHEDULE_COLUMN_CAROUSEL_INTERVAL_SECONDS,
    MIN_SCHEDULE_COLUMN_CAROUSEL_INTERVAL_SECONDS,
    MAX_SCHEDULE_COLUMN_CAROUSEL_INTERVAL_SECONDS
  );
